// Common email domain typos and their corrections
const emailDomainCorrections: Record<string, string> = {
  // Gmail typos
  "gmail.co": "gmail.com",
  "gmail.col": "gmail.com",
  "gmail.cm": "gmail.com",
  "gmail.con": "gmail.com",
  "gmail.cmo": "gmail.com",
  "gmai.com": "gmail.com",
  "gmial.com": "gmail.com",
  
  // Hotmail typos
  "hotmail.co": "hotmail.com",
  "hotmail.cm": "hotmail.com",
  "hotmail.con": "hotmail.com",
  
  // Yahoo typos
  "yahoo.co": "yahoo.com",
  "yahoo.cm": "yahoo.com",
  "yahoo.con": "yahoo.com",
  
  // Outlook typos
  "outlook.co": "outlook.com",
  "outlook.cm": "outlook.com",
  "outlook.con": "outlook.com",
  
  // Orange typos
  "orange.co": "orange.fr",
  "orange.cm": "orange.fr",
  
  // Wanadoo typos
  "wanadoo.co": "wanadoo.fr",
  "wanadoo.cm": "wanadoo.fr",
  
  // Free typos
  "free.co": "free.fr",
  "free.cm": "free.fr",
  
  // La Poste typos
  "laposte.co": "laposte.net",
  "laposte.cm": "laposte.net",
};

export interface EmailValidationResult {
  correctedEmail: string;
  wasCorrected: boolean;
  correctionMessage?: string;
}

/**
 * Normalizes and corrects common email typos
 * @param email - The email to normalize and correct
 * @returns An object with the corrected email and correction info
 */
export function normalizeAndCorrectEmail(email: string): EmailValidationResult {
  // Normalize: trim and lowercase
  const normalized = email.trim().toLowerCase();
  
  // Extract domain
  const atIndex = normalized.lastIndexOf("@");
  if (atIndex === -1) {
    return {
      correctedEmail: normalized,
      wasCorrected: false,
    };
  }
  
  const localPart = normalized.substring(0, atIndex);
  const domain = normalized.substring(atIndex + 1);
  
  // Check if domain has a known typo
  const correctedDomain = emailDomainCorrections[domain];
  
  if (correctedDomain) {
    const correctedEmail = `${localPart}@${correctedDomain}`;
    return {
      correctedEmail,
      wasCorrected: true,
      correctionMessage: `Email corrigé : ${domain} → ${correctedDomain}`,
    };
  }
  
  return {
    correctedEmail: normalized,
    wasCorrected: false,
  };
}
